document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('product-slider')) {
    class ProductSlider extends HTMLElement {
      constructor() {
        super()
        this.swiperPrev = null
        this.swiperNext = null
        this.swiperPagination = null
        this.swiperContainer = null
        this.swiperScrollbar = null
        this.slideshowSwiper = null
      }

      connectedCallback() {
        this.swiperPrev = this.querySelector('.swiper-button-prev')
        this.swiperNext = this.querySelector('.swiper-button-next')
        this.swiperContainer = this.querySelector('.swiper-container')
        this.swiperPagination = this.querySelector('.swiper-pagination')
        this.slideItems = this.querySelectorAll('.swiper-slide')

        if (this.swiperContainer) {
          this.initSwiper()
        }
      }

      initSwiper() {
        const autoplay = this.getAttribute('data-autoplay') === 'true'
        const loop = this.getAttribute('loop') === 'true' ? true : false
        const autoplayDelay =
          Number(this.getAttribute('data-autoplay-delay')) || 3000

        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.swiperNext,
            prevEl: this.swiperPrev,
          },
          pagination: {
            el: this.swiperPagination,
            clickable: true,
          },
        }

        if (autoplay) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        }

        this.slideshowSwiper = new Swiper(this.swiperContainer, swiperOptions)
      }
    }

    customElements.define('product-slider', ProductSlider)
  }
})
